export const REGIONS = [
  { id: 'baden-wuerttemberg', name: 'Baden-Württemberg', movingDays: 4 },
  { id: 'bayern', name: 'Bayern', movingDays: 0 },
  { id: 'berlin', name: 'Berlin', movingDays: 0 },
  { id: 'brandenburg', name: 'Brandenburg', movingDays: 1 },
  { id: 'bremen', name: 'Bremen', movingDays: 0 },
  { id: 'hamburg', name: 'Hamburg', movingDays: 0 },
  { id: 'hessen', name: 'Hessen', movingDays: 4 },
  { id: 'mecklenburg-vorpommern', name: 'Mecklenburg-Vorpommern', movingDays: 0 },
  { id: 'niedersachsen', name: 'Niedersachsen', movingDays: 0 },
  { id: 'nordrhein-westfalen', name: 'Nordrhein-Westfalen', movingDays: 3 },
  { id: 'rheinland-pfalz', name: 'Rheinland-Pfalz', movingDays: 6 },
  { id: 'saarland', name: 'Saarland', movingDays: 2 },
  { id: 'sachsen', name: 'Sachsen', movingDays: 1 },
  { id: 'sachsen-anhalt', name: 'Sachsen-Anhalt', movingDays: 2 },
  { id: 'schleswig-holstein', name: 'Schleswig-Holstein', movingDays: 2 },
  { id: 'thueringen', name: 'Thüringen', movingDays: 2 }
];

export const DEFAULT_REGION_ID = 'bayern';

export const REGION_HOLIDAYS = {
  'baden-wuerttemberg': [
    ['autumn-2026', 'autumn', 'Herbstferien', '2026-10-26', '2026-10-31'],
    ['christmas-2026', 'christmas', 'Weihnachtsferien', '2026-12-23', '2027-01-09'],
    ['easter-2027', 'easter', 'Osterferien', '2027-03-25', '2027-04-03'],
    ['pentecost-2027', 'pentecost', 'Pfingstferien', '2027-05-18', '2027-05-29'],
    ['summer-2027', 'summer', 'Sommerferien', '2027-07-29', '2027-09-11']
  ],
  bayern: [
    ['autumn-2026', 'autumn', 'Herbstferien', '2026-11-02', '2026-11-06'],
    ['christmas-2026', 'christmas', 'Weihnachtsferien', '2026-12-24', '2027-01-08'],
    ['winter-2027', 'winter', 'Frühjahrsferien', '2027-02-08', '2027-02-12'],
    ['easter-2027', 'easter', 'Osterferien', '2027-03-22', '2027-04-02'],
    ['pentecost-2027', 'pentecost', 'Pfingstferien', '2027-05-18', '2027-05-28'],
    ['summer-2027', 'summer', 'Sommerferien', '2027-08-02', '2027-09-13']
  ],
  berlin: [
    ['autumn-2026', 'autumn', 'Herbstferien', '2026-10-19', '2026-10-31'],
    ['christmas-2026', 'christmas', 'Weihnachtsferien', '2026-12-23', '2027-01-02'],
    ['winter-2027', 'winter', 'Winterferien', '2027-02-01', '2027-02-06'],
    ['easter-2027', 'easter', 'Osterferien', '2027-03-22', '2027-04-02'],
    ['pentecost-2027', 'pentecost', 'Himmelfahrt/Pfingsten', '2027-05-07', '2027-05-19'],
    ['summer-2027', 'summer', 'Sommerferien', '2027-07-01', '2027-08-14']
  ],
  brandenburg: [
    ['autumn-2026', 'autumn', 'Herbstferien', '2026-10-19', '2026-10-30'],
    ['christmas-2026', 'christmas', 'Weihnachtsferien', '2026-12-23', '2027-01-02'],
    ['winter-2027', 'winter', 'Winterferien', '2027-02-01', '2027-02-06'],
    ['easter-2027', 'easter', 'Osterferien', '2027-03-22', '2027-04-03'],
    ['pentecost-2027', 'pentecost', 'Pfingstferien', '2027-05-18', '2027-05-18'],
    ['summer-2027', 'summer', 'Sommerferien', '2027-07-01', '2027-08-14']
  ],
  bremen: [
    ['autumn-2026', 'autumn', 'Herbstferien', '2026-10-12', '2026-10-24'],
    ['christmas-2026', 'christmas', 'Weihnachtsferien', '2026-12-23', '2027-01-09'],
    ['winter-2027', 'winter', 'Winterferien', '2027-02-01', '2027-02-02'],
    ['easter-2027', 'easter', 'Osterferien', '2027-03-22', '2027-04-03'],
    ['pentecost-2027', 'pentecost', 'Himmelfahrt/Pfingsten', '2027-05-07', '2027-05-18'],
    ['summer-2027', 'summer', 'Sommerferien', '2027-07-08', '2027-08-18']
  ],
  hamburg: [
    ['autumn-2026', 'autumn', 'Herbstferien', '2026-10-19', '2026-10-30'],
    ['christmas-2026', 'christmas', 'Weihnachtsferien', '2026-12-21', '2027-01-01'],
    ['winter-2027', 'winter', 'Winterferien', '2027-01-29', '2027-03-12'],
    ['pentecost-2027', 'pentecost', 'Himmelfahrt/Pfingsten', '2027-05-07', '2027-05-14'],
    ['summer-2027', 'summer', 'Sommerferien', '2027-07-01', '2027-08-11']
  ],
  hessen: [
    ['autumn-2026', 'autumn', 'Herbstferien', '2026-10-05', '2026-10-17'],
    ['christmas-2026', 'christmas', 'Weihnachtsferien', '2026-12-23', '2027-01-12'],
    ['easter-2027', 'easter', 'Osterferien', '2027-03-22', '2027-04-02'],
    ['summer-2027', 'summer', 'Sommerferien', '2027-06-28', '2027-08-06']
  ],
  'mecklenburg-vorpommern': [
    ['autumn-2026', 'autumn', 'Herbstferien', '2026-10-15', '2026-10-24'],
    ['christmas-2026', 'christmas', 'Weihnachtsferien', '2026-12-21', '2027-01-02'],
    ['winter-2027', 'winter', 'Winterferien', '2027-02-08', '2027-02-19'],
    ['easter-2027', 'easter', 'Osterferien', '2027-03-24', '2027-04-02'],
    ['pentecost-2027', 'pentecost', 'Himmelfahrt/Pfingsten', '2027-05-07', '2027-05-18'],
    ['summer-2027', 'summer', 'Sommerferien', '2027-07-05', '2027-08-14']
  ],
  niedersachsen: [
    ['autumn-2026', 'autumn', 'Herbstferien', '2026-10-12', '2026-10-24'],
    ['christmas-2026', 'christmas', 'Weihnachtsferien', '2026-12-23', '2027-01-09'],
    ['winter-2027', 'winter', 'Winterferien', '2027-02-01', '2027-02-02'],
    ['easter-2027', 'easter', 'Osterferien', '2027-03-22', '2027-04-03'],
    ['pentecost-2027', 'pentecost', 'Himmelfahrt/Pfingsten', '2027-05-07', '2027-05-18'],
    ['summer-2027', 'summer', 'Sommerferien', '2027-07-08', '2027-08-18']
  ],
  'nordrhein-westfalen': [
    ['autumn-2026', 'autumn', 'Herbstferien', '2026-10-17', '2026-10-31'],
    ['christmas-2026', 'christmas', 'Weihnachtsferien', '2026-12-23', '2027-01-06'],
    ['easter-2027', 'easter', 'Osterferien', '2027-03-22', '2027-04-03'],
    ['pentecost-2027', 'pentecost', 'Pfingstferien', '2027-05-18', '2027-05-18'],
    ['summer-2027', 'summer', 'Sommerferien', '2027-07-19', '2027-08-31']
  ],
  'rheinland-pfalz': [
    ['autumn-2026', 'autumn', 'Herbstferien', '2026-10-05', '2026-10-16'],
    ['christmas-2026', 'christmas', 'Weihnachtsferien', '2026-12-23', '2027-01-08'],
    ['easter-2027', 'easter', 'Osterferien', '2027-03-22', '2027-04-02'],
    ['summer-2027', 'summer', 'Sommerferien', '2027-06-28', '2027-08-06']
  ],
  saarland: [
    ['autumn-2026', 'autumn', 'Herbstferien', '2026-10-05', '2026-10-16'],
    ['christmas-2026', 'christmas', 'Weihnachtsferien', '2026-12-21', '2026-12-31'],
    ['winter-2027', 'winter', 'Winterferien', '2027-02-08', '2027-02-12'],
    ['easter-2027', 'easter', 'Osterferien', '2027-03-30', '2027-04-09'],
    ['summer-2027', 'summer', 'Sommerferien', '2027-06-28', '2027-08-06']
  ],
  sachsen: [
    ['autumn-2026', 'autumn', 'Herbstferien', '2026-10-12', '2026-10-24'],
    ['christmas-2026', 'christmas', 'Weihnachtsferien', '2026-12-23', '2027-01-02'],
    ['winter-2027', 'winter', 'Winterferien', '2027-02-08', '2027-02-19'],
    ['easter-2027', 'easter', 'Osterferien', '2027-03-26', '2027-04-02'],
    ['pentecost-2027', 'pentecost', 'Himmelfahrt/Pfingsten', '2027-05-07', '2027-05-18'],
    ['summer-2027', 'summer', 'Sommerferien', '2027-07-10', '2027-08-20']
  ],
  'sachsen-anhalt': [
    ['autumn-2026', 'autumn', 'Herbstferien', '2026-10-19', '2026-10-30'],
    ['christmas-2026', 'christmas', 'Weihnachtsferien', '2026-12-21', '2027-01-02'],
    ['winter-2027', 'winter', 'Winterferien', '2027-02-01', '2027-02-06'],
    ['easter-2027', 'easter', 'Osterferien', '2027-03-22', '2027-03-27'],
    ['pentecost-2027', 'pentecost', 'Pfingstferien', '2027-05-15', '2027-05-22'],
    ['summer-2027', 'summer', 'Sommerferien', '2027-07-10', '2027-08-20']
  ],
  'schleswig-holstein': [
    ['autumn-2026', 'autumn', 'Herbstferien', '2026-10-12', '2026-10-24'],
    ['christmas-2026', 'christmas', 'Weihnachtsferien', '2026-12-21', '2027-01-06'],
    ['easter-2027', 'easter', 'Osterferien', '2027-03-30', '2027-04-10'],
    ['pentecost-2027', 'pentecost', 'Himmelfahrt/Pfingsten', '2027-05-07', '2027-05-07'],
    ['summer-2027', 'summer', 'Sommerferien', '2027-07-03', '2027-08-14']
  ],
  thueringen: [
    ['autumn-2026', 'autumn', 'Herbstferien', '2026-10-12', '2026-10-24'],
    ['christmas-2026', 'christmas', 'Weihnachtsferien', '2026-12-23', '2027-01-02'],
    ['winter-2027', 'winter', 'Winterferien', '2027-02-01', '2027-02-06'],
    ['easter-2027', 'easter', 'Osterferien', '2027-03-22', '2027-04-03'],
    ['pentecost-2027', 'pentecost', 'Himmelfahrt/Pfingsten', '2027-05-07', '2027-05-07'],
    ['summer-2027', 'summer', 'Sommerferien', '2027-07-10', '2027-08-20']
  ]
};

export function getRegion(regionId) {
  return REGIONS.find((region) => region.id === regionId) || REGIONS[1];
}